<p-table stripedRows #dtPayroll
    [value]="items | orderBy: 'Sequencenbr'"
    dataKey="id"
    editMode="row"
    scrollHeight="65vh"
    [style]="{ 'min-width': '70em', width: '100%' }"
    [scrollable]="true"
    [virtualRowHeight]="30"
    (onRowReorder)="onRowReorderHandler($event)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header>
        <tr>
            <!-- Reorder grabber-->
            <th class="status-cell"></th>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- Status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Name-->
            <th>
                Export Field
                <p-sortIcon
                    pSortableColumn="Fieldname"
                    field="Fieldname"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Description-->
            <th>
                Description
                <p-sortIcon
                    pSortableColumn="Fielddesc"
                    field="Fielddesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- Header-->
            <th>
                Column Header
                <p-sortIcon
                    pSortableColumn="Colheader"
                    field="Colheader"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
            <!-- IsStandard-->
            <th >Include in Export File?</th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pReorderableRow]="ri"
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === item?.id
            }"
        >
            <td class="status-cell">
                <span
                    class="pi pi-bars"
                    pReorderableRowHandle
                    title="click and drag to re-order"
                ></span>
            </td>
            <!-- Edit -->
            <td class="edit-cell">
                <!-- for a new row -->
                <button
                    *ngIf="item?.id === -1 && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== -1
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Name-->
            <td class="disabled">
                {{ item?.Fieldname }}
            </td>
            <!-- Description-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input type="text" [(ngModel)]="item.Fielddesc" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.Fielddesc }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Fielddesc }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Header-->
            <td>
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input type="text" [(ngModel)]="item.Colheader" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.Colheader }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.Colheader }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- IsStandard-->
            <td>
                <p-checkbox
                    [(ngModel)]="item.Isstandard"
                    [binary]="true"
                    (onChange)="onRowEditSave(item)"
                ></p-checkbox>
            </td>
        </tr>
    </ng-template>
</p-table>
